/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublicFailureTypeVm
 */
export interface PublicFailureTypeVm {
    /**
     * 
     * @type {string}
     * @memberof PublicFailureTypeVm
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicFailureTypeVm
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PublicFailureTypeVm
     */
    specialCase?: boolean | null;
}

export function PublicFailureTypeVmFromJSON(json: any): PublicFailureTypeVm {
    return PublicFailureTypeVmFromJSONTyped(json, false);
}

export function PublicFailureTypeVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicFailureTypeVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'specialCase': !exists(json, 'specialCase') ? undefined : json['specialCase'],
    };
}

export function PublicFailureTypeVmToJSON(value?: PublicFailureTypeVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'specialCase': value.specialCase,
    };
}


